import React, { useState } from 'react';
import './ToolUseNode.css';

function ToolUseNode({ toolUse }) {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const { name, status, input, result, error } = toolUse;
  
  const getStatusIcon = () => {
    switch (status) {
      case 'executing':
        return '⏳';
      case 'completed':
        return '';
      case 'error':
        return '❌';
      default:
        return '🔧';
    }
  };
  
  const getStatusClass = () => {
    switch (status) {
      case 'executing':
        return 'executing';
      case 'completed':
        return 'completed';
      case 'error':
        return 'error';
      default:
        return 'pending';
    }
  };
  
  const formatJson = (data) => {
    if (!data) return '';
    try {
      if (typeof data === 'string') {
        return data;
      }
      return JSON.stringify(data, null, 2);
    } catch (e) {
      return String(data);
    }
  };
  
  return (
    <div className={`tool-use-node ${getStatusClass()}`}>
      <div 
        className="tool-use-header" 
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="tool-use-status">
          <span className="status-icon">{getStatusIcon()}</span>
          <span className="tool-name">{name}</span>
        </div>
        <div className="tool-use-actions">
          {(result || error || input) && (
            <span className="expand-icon">{isExpanded ? '▼' : '▶'}</span>
          )}
        </div>
      </div>
      
      {isExpanded && (
        <div className="tool-use-details">
          {input && Object.keys(input).length > 0 && (
            <div className="tool-detail-section">
              <div className="tool-detail-label">Input:</div>
              <pre className="tool-detail-content">{formatJson(input)}</pre>
            </div>
          )}
          
          {error && (
            <div className="tool-detail-section error-section">
              <div className="tool-detail-label">Error:</div>
              <pre className="tool-detail-content">{formatJson(error)}</pre>
            </div>
          )}
          
          {result && (
            <div className="tool-detail-section">
              <div className="tool-detail-label">Result:</div>
              <pre className="tool-detail-content">{formatJson(result)}</pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ToolUseNode;
